import { useDebounce } from '@utils/useDebounce';
import { useFillFormValueMutation } from '../../../../../gql';
import { FormFieldValues } from '../types';
import { useFormFillerHelpers } from '../useFormFillerHelpers';
import { formFillerValueToFormValueInput } from '../utils';

export const autoSaveTimeout = 500;

export const useFormFieldFillerForm = () => {

  const { onFormFillSaving, onFormFillSuccess: onSuccess, onFormFillError: onError } = useFormFillerHelpers();

  const { mutate: fillFormValue } = useFillFormValueMutation({ onError, onSuccess });

  const onSubmit = useDebounce((value: FormFieldValues) => {
    onFormFillSaving();    
    fillFormValue({ input: { formValue: formFillerValueToFormValueInput(value) } });
  }, autoSaveTimeout);

  return { onSubmit };
};